import React from 'react'
import {
  Dialog as BaseDialog,
  Container,
  createStyles,
  withStyles,
} from '@material-ui/core'

import Nav from './Nav'
import Links from '../../Links'
import { expandNavBreakpoint } from '../../../styles'

const styles = (theme) => {
  return createStyles({
    dialog: {
      [theme.breakpoints.up(expandNavBreakpoint)]: {
        display: 'none',
      },
    },
  })
}

const Dialog = ({ isMenuOpen, hideMenu, classes }) => {
  return (
    <BaseDialog
      fullScreen
      open={isMenuOpen}
      onClose={hideMenu}
      className={classes.dialog}
    >
      <Nav hideMenu={hideMenu} />
      <Container>
        <Links hideMenu={hideMenu} />
      </Container>
    </BaseDialog>
  )
}

export default withStyles(styles)(Dialog)
